// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformStatuses = {
  online: "在线",
  degraded: "降级",
  offline: "离线",
  queued: "排队中",
  stopped: "已停止",
  unknown: "未知",
  unintegrated: "未接入",
  reachable: "入口在线",
} as const;
